"use client";
import React, { useEffect, useState } from "react";
import api from "../api";

const WeeklyDeals = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Weekly Deals | Workgear365";
    fetchDeals();
  }, []);

  const fetchDeals = async () => {
    try {
      const res = await api.get("/api/weekly-deals");
      setProducts(res.data || []);
    } catch (err) {
      console.error("Error fetching weekly deals:", err);
    } finally {
      setLoading(false);
    }
  };
 const getSafeColor = (code) => {
  if (!code) return "#cccccc";

  const c = code.trim();

  // valid hex
  if (/^#([0-9A-F]{3}){1,2}$/i.test(c)) return c;

  // rgb/rgba support
  if (c.startsWith("rgb")) return c;

  return "#cccccc";
};
  return (
    <div className="wg-plp">
      

      
        {loading && <div>Loading...</div>}

        {!loading && products.length === 0 && (
          <div>No weekly deals available.</div>
        )}

           <section className="section weekly-deals section-soft" style={{ borderTop: "4px solid rgba(249,142,76,0.30)" }}>
          
          <div className="weekly-panel">
            <div className="weekly-deals-grid">
            
              {products.map((product) => (
                        <article key={product.id} className="card-utility weekly-deal-card">
                          <a className="weekly-deal-link" href={`/products/${product.id}/${encodeURIComponent(product.name)}`}>
                            <div className="weekly-deal-image" style={{ backgroundImage: `url(${product.frontimage})` }}>
                            {product.description?.toLowerCase().includes("ansi") && (
                              <span className="weekly-badge">ANSI Class 3</span>
                            )}</div>
                            <div className="weekly-deal-content">
                              <span className="weekly-brand">{product.Brand}</span>
                              <h3 className="card-title">{product.name}</h3>
                              <div className="weekly-price"><span className="current">${Number(product.salePrice || 0).toFixed(2)}</span>
                                  {Number(product.customerPrice) !== 0 && (
                                        <span className="old">
                                          ${Number(product.customerPrice).toFixed(2)}
                                        </span>
                                  )}
                              </div>
                              <div className="weekly-swatches" aria-label="Available colors">
                               {product.colors?.map((c, i) => {
                                  const bg = getSafeColor(c.color_code);

                                  return (
                                    <span
                                      key={i}
                                      className="weekly-swatch"
                                      title={c.colorName}
                                      style={{
                                        background: bg,
                                        border: bg.toLowerCase() === "#ffffff" ? "1px solid #999" : "none"
                                      }}
                                    />
                                  );
                                })}
                              </div>
                              
                            </div>
                          </a>
                        </article>
                ))}
          </div>
          </div>
        </section>
      </div>
    
  );
};

export default WeeklyDeals;